var _defs, _rect, _circle, _circle2, _circle3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateKitBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 1200,
    viewBox: "0 0 1600 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgBase",
    x1: 0,
    y1: 0,
    x2: 1600,
    y2: 1200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EEF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECFEFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "blobPurple",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320 240) rotate(30) scale(520 360)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C3AED",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "blobPink",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1280 260) rotate(-20) scale(430 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4899",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC4899",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "blobBlue",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1220 920) rotate(-18) scale(520 360)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2563EB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lineGrad",
    x1: 240,
    y1: 1030,
    x2: 1440,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B5CF6",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B6D4",
    stopOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1200,
    fill: "url(#bgBase)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 240,
    r: 520,
    fill: "url(#blobPurple)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1280,
    cy: 260,
    r: 430,
    fill: "url(#blobPink)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1220,
    cy: 920,
    r: 520,
    fill: "url(#blobBlue)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 1040C360 900 620 980 860 780C1080 600 1280 420 1480 220",
    stroke: "url(#lineGrad)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 860C300 760 520 820 730 680C960 520 1170 360 1490 120",
    stroke: "url(#lineGrad)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "8 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 1110C520 980 760 1010 980 860C1160 730 1290 590 1430 410",
    stroke: "url(#lineGrad)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateKitBackground);
export default __webpack_public_path__ + "static/media/generate-kit-background.391a4bed7d4fd3fa771c8d87b41cd6a9.svg";
export { ForwardRef as ReactComponent };